export default __webpack_public_path__ + "6e51eabf9a50e0838393ef35a5ec068a.png";